import { defineMessages } from "react-intl";

export const messages = defineMessages({
	title: {
		id: "form.sign_up",
		defaultMessage: "Regisztráció"
	},
	help: {
		id: "form.sign_up.help",
		defaultMessage: "A regisztrációhoz kérjük töltse ki az alábbi adatokat."
	},
	submit: {
		id: "form.sign_up.submit",
		defaultMessage: "Regisztráció"
	},
	signInLink: {
		id: "form.sign_up.sign_in_link",
		defaultMessage:
			"Már van felhasználói fiókja? Kattintson ide a BELÉPÉS-hez."
	},
	toc: {
		id: "form.sign_up.toc",
		defaultMessage: "Felhasználási feltételek"
	},
	accept: {
		id: "form.sign_up.accept",
		defaultMessage: "Elfogadom"
	}
});

export const labels = defineMessages({
	title: {
		id: "form.sign_up.title",
		defaultMessage: "Titulus"
	},
	firstName: {
		id: "form.sign_up.first_name",
		defaultMessage: "Keresztnév"
	},
	lastName: {
		id: "form.sign_up.last_name",
		defaultMessage: "Vezetéknév"
	},
	email: {
		id: "form.sign_up.email",
		defaultMessage: "Email cím"
	},
	organization: {
		id: "form.sign_up.organization",
		defaultMessage: "Szervezet"
	},
	module: {
		id: "form.sign_up.module",
		defaultMessage: "Modul"
	},
	phoneNumber: {
		id: "form.sign_up.phone_number",
		defaultMessage: "Telefonszám"
	},
	occupation: {
		id: "form.sign_up.occupation",
		defaultMessage: "Foglalkozás"
	},
	stampNumber: {
		id: "form.sign_up.stamp_number",
		defaultMessage: "Pecsétszám"
	},
	language: {
		id: "form.sign_up.language",
		defaultMessage: "Nyelv"
	},
	acceptTOCLeft: {
		id: "form.sign_up.accept_toc.left",
		defaultMessage: "Elolvastam és regisztrációmmal elfogadom a"
	},
	acceptTOCRight: {
		id: "form.sign_up.accept_toc.right",
		defaultMessage: "felhasználási feltételeket"
	},
	password: {
		id: "form.sign_up.password",
		defaultMessage: "Jelszó"
	},
	passwordAgain: {
		id: "form.sign_up.password_again",
		defaultMessage: "Jelszó újra"
	}
});

export const errors = defineMessages({
	firstNameRequired: {
		id: "form.sign_up.first_name.error.required",
		defaultMessage: "A keresztnév kötelező."
	},
	lastNameRequired: {
		id: "form.sign_up.last_name.error.required",
		defaultMessage: "A vezetéknév kötelező."
	},
	emailRequired: {
		id: "form.sign_up.email.error.required",
		defaultMessage: "Az email cím kötelező."
	},
	phoneNumberRequired: {
		id: "form.sign_up.phone_number.error.required",
		defaultMessage: "A telefonszám kötelező."
	},
	phoneNumberFormat: {
		id: "form.sign_up.phone_number.error.format",
		defaultMessage: "A telefonszám formátuma nem megfelelő."
	},
	occupationRequired: {
		id: "form.sign_up.occupation.error.required",
		defaultMessage: "A foglalkozás kötelező."
	},
	stampNumberRequired: {
		id: "form.sign_up.stamp_number.error.required",
		defaultMessage: "A pecsétszám kötelező."
	},
	stampNumberFormat: {
		id: "form.sign_up.stamp_number.error.format",
		defaultMessage: "A pecsétszám formátuma nem megfelelő."
	},
	languageRequired: {
		id: "form.sign_up.language.error.required",
		defaultMessage: "A nyelv kötelező."
	},
	passwordRequired: {
		id: "form.sign_up.password.error.required",
		defaultMessage: "A jelszó kötelező."
	},
	passwordMinLength: {
		id: "form.sign_up.password.error.min_length",
		defaultMessage: "A jelszó minimalális hossza {minLength}."
	},
	passwordConst: {
		id: "form.sign_up.password.error.const",
		defaultMessage: "A jelszavak nem egyeznek meg."
	}
});
